import { Row, Typography } from "antd";
import React, { useEffect } from "react";
import "./index.css";

const ConfirmChangeInfo = (props) => {
  const { base64FileChange } = props;
  useEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const { Text  } = Typography;
  return (
    <>
      <Row>
        <Text italic className="note-confirm text-fw-500">
          <Text type="danger">Lưu ý</Text>: Quý khách cần ký file DC-01 để hoàn
          tất yêu cầu gửi điều chỉnh thông tin.
        </Text>
      </Row>
      <Row>
        <Text italic className="text-fw-500">
          Để ký file cần thực hiện các bước sau:
        </Text>
      </Row>
      <Text italic>
        <ol>
          <li>Kiểm tra thông tin file DC-01 dưới đây</li>
          <li>Cắm chữ ký số cần điều chỉnh thông tin</li>
          <li>
            Cài FastCA plugin{" "}
            <a href="https://gen.fastca.vn/tao-lap-chung-thu/downloadPlugin" download>
              Tại đây
            </a>{" "}
            (Nếu đã cài thì bỏ qua bước này)
          </li>
          <li>Nhấn ký xác nhận</li>
        </ol>
      </Text>

      {base64FileChange && (
        <Row className="iframe-view-pdf-infochange">
          <iframe
            src={"data:application/pdf;base64," + base64FileChange}
            title="viewPDF"
            className="w--100 hr--38"
            loading="lazy"
            width="100%"
            allow="accelerometer autoplay encrypted-media gyroscope picture-in-picture"
            allowFullScreen
          ></iframe>
        </Row>
      )}
    </>
  );
};

export default ConfirmChangeInfo;
